import { useEffect, useState } from "react";
import { MapPin, Phone, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PageHeader } from "@/components/portal/widgets";
import api from "@/lib/api";

export default function StoresAdmin() {
  const [stores, setStores] = useState([]);
  useEffect(() => { api.get("/stores").then((r) => setStores(r.data)).catch(() => {}); }, []);

  return (
    <div className="animate-fade-up">
      <PageHeader title="Store Network" subtitle={`${stores.length} stores across the network.`} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {stores.map((s) => (
          <Card key={s.id} data-testid={`store-card-${s.id}`} className="p-5 border-slate-200/80 dark:border-slate-800">
            <div className="flex items-center justify-between">
              <h3 className="font-heading font-semibold">{s.name}</h3>
              <Badge className={s.is_franchise ? "bg-orange-100 text-orange-700" : "bg-yellow-200 text-yellow-700"}>{s.is_franchise ? "Franchise" : "Company"}</Badge>
            </div>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-2"><MapPin className="w-3.5 h-3.5" /> {s.address}</p>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1"><Clock className="w-3.5 h-3.5" /> {s.hours}</p>
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1"><Phone className="w-3.5 h-3.5" /> {s.phone}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
